var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53207 20.4514C4.15953 18.7085 5.30946 17.2018 6.82495 16.1367C8.34044 15.0715 10.1477 14.5 12 14.5C13.8523 14.5 15.6596 15.0715 17.175 16.1367C18.6905 17.2018 19.8405 18.7085 20.4679 20.4514",
    stroke: "#A6ABB0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7639 11.8042C10.2644 11.6419 9.80164 11.3828 9.40221 11.0416C9.00278 10.7005 8.67445 10.284 8.43597 9.81596C8.1975 9.34793 8.05354 8.8375 8.01233 8.31384C7.97112 7.79017 8.03345 7.26351 8.19577 6.76393C8.3581 6.26435 8.61723 5.80164 8.95838 5.40221C9.29952 5.00278 9.716 4.67445 10.184 4.43597C10.6521 4.1975 11.1625 4.05354 11.6862 4.01233C12.2098 3.97112 12.7365 4.03345 13.2361 4.19577C13.7356 4.3581 14.1984 4.61723 14.5978 4.95838C14.9972 5.29952 15.3256 5.716 15.564 6.18404C15.8025 6.65207 15.9465 7.1625 15.9877 7.68616C16.0289 8.20983 15.9665 8.73649 15.8042 9.23607C15.6419 9.73565 15.3828 10.1984 15.0416 10.5978C14.7005 10.9972 14.284 11.3256 13.816 11.564C13.3479 11.8025 12.8375 11.9465 12.3138 11.9877C11.7902 12.0289 11.2635 11.9665 10.7639 11.8042L10.7639 11.8042Z",
    stroke: "#A6ABB0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.bf13b043a1a114d09215502ac148cd09.svg";
export { ForwardRef as ReactComponent };